export default __webpack_public_path__ + "08e042a3e38a8a55f14fd8654300d5f7.svg";